import "./CTA.css"

export default function CTA(props) {
    return(
        <>
        <div className="cta-cont">
            <p className="cta-text">Ready to launch your product?</p>
            <p className="cta-subtext">From apps to websites, we've got you covered. Bring your vision to life.</p>
            {/* <button className="cta-button">Let's Start Building</button> */}
            <button className="cta-primary" onClick={() => props.isForm(true)}>Let's Start Building</button>

        </div>
        </>
    )
}
